import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ChristmasService {
  private readonly sispacNatal: boolean = false;

  isChristmasMode(): boolean {
    return this.sispacNatal;
  }

  getLogoPath(christmasPath: string, originalPath: string): string {
    return this.isChristmasMode() ? christmasPath : originalPath;
  }
}

